export const iconFontAwesomeArrowsArrowDownShortWide = (
	<i className="fa-solid fa-arrow-down-short-wide"></i>
);
